import { getParameterByName } from '@hotjar/webapp/features/Playbacks/store/utils';

/**
 * Decides whether we should show the secure recording modal. This is designed for when people view
 * a recording from the visitor lookup result page.
 *
 * XXX: Currently this is not implemented and we simply hide the modal.
 */
export const shouldShowSecureModal = (): boolean => {
  // This should show when a visitor lookup request token is being used. We might also want to consider
  // using cookies/localStorage to retain this.
  return !!getParameterByName('secure');
};
